/**
 * Returns a map of folder name to count of folders with same display name
 * @param folders - list of folders
 */
export default function getFolderNameToCountMap(folders) {
    var folderNameCountMap = {};
    folders.map(function (item) {
        var displayName = item.displayName.toLowerCase();
        if (folderNameCountMap[displayName]) {
            folderNameCountMap[displayName]++;
        }
        else {
            folderNameCountMap[displayName] = 1;
        }
    });
    return folderNameCountMap;
}
//# sourceMappingURL=getFolderNameToCountMap.js.map